module.exports = __webpack_public_path__ + "img/multiTank_m.8f3edd0a.png";